module.exports = __webpack_public_path__ + "img/103-A.dc1ff311.png";